module.exports = __webpack_public_path__ + "img/fiftythree-pencil.bcee88f0.jpg";